/**
 * Porte d'age du panier.
 *
 * Chargee depuis le <head> et jamais depuis le panier lui-meme : un <script>
 * insere par le morphing d'une section ne s'execute pas, et le tiroir panier
 * est rendu de cette facon des que le panier etait vide au chargement de la
 * page. Le verrou lui-meme est en CSS (`.vino-age:not(:has(...:checked))`),
 * donc il tient meme avant que ce module soit evalue. Ici on ajoute la couche
 * accessibilite (`inert`) et la memorisation du consentement sur la session.
 */
(() => {
  const KEY = 'vinoAgeConfirmed';

  // Repli quand sessionStorage est inaccessible (navigation privee verrouillee,
  // cookies tiers bloques) : sans lui, chaque refresh decocherait la case.
  let inMemory = false;

  const confirmed = () => {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch {
      return inMemory;
    }
  };

  const remember = (value) => {
    inMemory = value;
    try {
      sessionStorage.setItem(KEY, value ? '1' : '0');
    } catch {
      // L'etat en memoire prend le relais pour la duree de la page.
    }
  };

  const refresh = () => {
    const ok = confirmed();

    for (const wrap of document.querySelectorAll('[data-vino-age-wrap]')) {
      const box = wrap.querySelector('[data-vino-age-box]');
      const gate = wrap.querySelector('[data-vino-age-gate]');
      const hint = wrap.querySelector('[data-vino-age-hint]');

      if (box && box.checked !== ok) box.checked = ok;
      gate?.toggleAttribute('inert', !ok);
      wrap.classList.toggle('vino-age--locked', !ok);
      if (hint && ok) hint.hidden = true;
    }
  };

  // Le re-rendu d'une section se termine apres l'evenement, d'ou le second passage.
  // Minuteur et pas requestAnimationFrame : ce dernier ne se declenche pas quand
  // l'onglet est en arriere-plan, et le panier peut etre mis a jour dans cet etat.
  const refreshAfterRender = () => {
    refresh();
    setTimeout(refresh, 0);
  };

  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('[data-vino-age-box]')) return;
    remember(event.target.checked);
    refresh();
  });

  document.addEventListener('click', (event) => {
    const wrap = event.target.closest?.('[data-vino-age-wrap]');
    if (!wrap || confirmed()) return;
    if (event.target.closest('[data-vino-age-box], .vino-age__row')) return;
    const hint = wrap.querySelector('[data-vino-age-hint]');
    if (hint) hint.hidden = false;
  });

  // Filet de securite independant du DOM : le tiroir panier est insere par
  // morphing apres l'evenement de mise a jour, donc `inert` peut manquer sur ce
  // premier rendu. On bloque alors la soumission plutot que le bouton.
  document.addEventListener(
    'submit',
    (event) => {
      const wraps = document.querySelectorAll('[data-vino-age-wrap]');
      if (!wraps.length || confirmed()) return;
      if (event.target.id !== 'cart-form' && !event.target.querySelector?.('[name="checkout"]')) return;

      event.preventDefault();
      // La page panier et le tiroir coexistent dans le DOM : on affiche le
      // message partout plutot que de deviner lequel des deux est visible.
      for (const wrap of wraps) {
        const hint = wrap.querySelector('[data-vino-age-hint]');
        if (hint) hint.hidden = false;
      }
    },
    true
  );

  document.addEventListener('shopify:cart:lines-update', refreshAfterRender);
  document.addEventListener('shopify:section:load', refreshAfterRender);
  document.addEventListener('theme-drawer:open', refreshAfterRender);

  refresh();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  }
})();
